export default {
  steps: {
    discount: 'Korting',
    mobile_app: 'Mobiele app',
    business_info: 'Bedrijfsgegevens',
    create_preview: 'Voorbeeldcontract aanmaken',
    preview: 'Contract bekijken',
    sign: 'Contract ondertekenen',
  },
  buttons: {
    back: 'Terug',
    continue: 'Doorgaan',
  },
  agreement:
    'Overstappen naar jaarlijks past de korting van {{discount}}% toe op je {{plan}}-abonnement. Je facturering gaat maandelijks door voor {{amount}} per maand met een verbintenis van {{months}} maanden.',
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    failed_to_switch: 'Overstappen naar jaarlijks mislukt',
    switched_to_annual: 'Contract overgezet naar jaarlijks 👌',
  },
};
